import React, { useMemo, useState } from "react";
import style from "./ProductResults.module.scss";
import { ResourceCard } from "../ClinicalResources/ResourceCard";
import { ProductCardSkeletonList } from "../Products/ProductCardSkeletonList";
import { mapToResource, TABS } from "./utils";
import constants from "../../../../constants/constants.json";

const ProductResults = ({ formularyData, cardLoading, onCategorySelect, onBack }) => {
  const [activeTab, setActiveTab] = useState(null);

  const hasFormulary = !!formularyData?.formulary?.length;
  const hasNonFormulary = !!formularyData?.nonFormulary?.length;
  const hasAnyRecommendation = hasFormulary || hasNonFormulary;

  const defaultTab = !hasFormulary && hasNonFormulary ? TABS.NON_FORMULARY : TABS.FORMULARY;
  const selectedTab = activeTab ?? defaultTab;

  const list = useMemo(() => {
    if (!formularyData) return [];
    const source = selectedTab === TABS.FORMULARY ? formularyData.formulary : formularyData.nonFormulary;
    return (source || []).map(mapToResource);
  }, [formularyData, selectedTab]);

  const handleSelect = (key) => {
    const resource = list.find((r) => r.key === key);
    if (!resource || !resource.materialCount) return;
    onCategorySelect?.({
      name: resource.key,
      materialNumber: resource.materialNumber,
      isFormulary: selectedTab === TABS.FORMULARY ? 1 : 0,
    });
  };

  const emptyMessage =
    selectedTab === TABS.FORMULARY ? constants.home.noFormularyProductRecommendation : constants.home.noNonFormularyProductRecommendation;

  const tabsDisabled = cardLoading || !formularyData || !hasAnyRecommendation;

  return (
    <div className={style.results}>
      <button type="button" className={style.back_link} onClick={onBack}>
        ‹ Back
      </button>

      <div className={style.tabs} role="tablist" aria-label="Product source">
        <button
          type="button"
          role="tab"
          disabled={tabsDisabled}
          aria-selected={!tabsDisabled && selectedTab === TABS.FORMULARY}
          className={`${style.tab} ${!tabsDisabled && selectedTab === TABS.FORMULARY ? style.tab_active : ""} ${
            tabsDisabled ? style.tab_disabled : ""
          }`}
          onClick={() => setActiveTab(TABS.FORMULARY)}
        >
          Formulary
        </button>
        <button
          type="button"
          role="tab"
          disabled={tabsDisabled}
          aria-selected={!tabsDisabled && selectedTab === TABS.NON_FORMULARY}
          className={`${style.tab} ${!tabsDisabled && selectedTab === TABS.NON_FORMULARY ? style.tab_active : ""} ${
            tabsDisabled ? style.tab_disabled : ""
          }`}
          onClick={() => setActiveTab(TABS.NON_FORMULARY)}
        >
          Non-Formulary
        </button>
      </div>

      <div className={style.card_list}>
        {cardLoading ? (
          <ProductCardSkeletonList count={4} />
        ) : !formularyData || !hasAnyRecommendation ? (
          <p className={style.empty}>{constants.home.noProductRecommendation}</p>
        ) : list.length ? (
          list.map((resource) => <ResourceCard key={resource.key} resource={resource} onClick={handleSelect} disabled={!resource.materialCount} />)
        ) : (
          <p className={style.empty}>{emptyMessage}</p>
        )}
      </div>
    </div>
  );
};

export default ProductResults;
